"use client";

import React, { useState } from "react";
import { Check, ChevronRight } from "lucide-react";

export default function PricingSection() {
    const [isAnnual, setIsAnnual] = useState(false);

    const handleEssencialClick = () => {
        window.location.href = "https://app.sapieduca.com.br/ia";
    };

    const handleProClick = () => {
        window.location.href = "https://app.sapieduca.com.br/ia/assinatura";
    };

    const handleEscolaClick = () => {
        window.location.href = "https://forms.gle/AMtLVqGXTkW4eTUr9";
    };

    return (
        <section id="Pricing" className="py-24 bg-white relative">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center mb-16">
                    <h2 className="text-4xl md:text-5xl font-black mb-6 tracking-tight text-[#3266cc]">Planos e Preços</h2>
                    <p className="text-xl text-slate-600 font-medium max-w-2xl mx-auto leading-relaxed">
                        Escolha o plano perfeito para potencializar sua prática pedagógica com IA.
                    </p>
                </div>

                <div className="flex justify-center mb-16">
                    <div className="bg-slate-100 p-1.5 rounded-full inline-flex items-center border border-slate-200 shadow-sm">
                        <button
                            onClick={() => setIsAnnual(false)}
                            className={`px-8 py-2.5 rounded-full text-sm font-bold transition-all duration-300 ${!isAnnual ? "bg-white text-[#3266cc] shadow-md scale-100" : "text-slate-500 hover:text-slate-800"
                                }`}
                        >
                            Mensal
                        </button>
                        <button
                            onClick={() => setIsAnnual(true)}
                            className={`px-8 py-2.5 rounded-full text-sm font-bold transition-all duration-300 flex items-center gap-2 ${isAnnual ? "bg-white text-[#3266cc] shadow-md scale-100" : "text-slate-500 hover:text-slate-800"
                                }`}
                        >
                            Anual
                            <span className={`text-[10px] px-2 py-0.5 rounded-full font-black ${isAnnual ? "bg-[#15b3a8] text-white" : "bg-slate-200 text-slate-500"}`}>
                                33% OFF
                            </span>
                        </button>
                    </div>
                </div>

                <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto items-stretch">
                    {/* Essencial */}
                    <div className="bg-white rounded-[3rem] p-10 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.08)] border border-slate-100 flex flex-col hover:shadow-2xl hover:scale-[1.02] transition-all duration-500 group">
                        <div className="mb-6">
                            <span className="text-xs font-black text-slate-400 uppercase tracking-[0.2em]">ESSENCIAL</span>
                            <div className="mt-2 flex items-baseline">
                                <span className="text-5xl font-black text-[#3266cc] tracking-tighter">Gratuito</span>
                            </div>
                        </div>
                        <p className="text-slate-500 text-lg mb-10 leading-relaxed font-medium">
                            Perfeito para começar sua jornada com IA na educação básica.
                        </p>

                        <div className="space-y-4 mb-12 flex-grow">
                            {[
                                "1 geração por dia",
                                "Alinhamento total à BNCC",
				"Recursos de diversidade",
				"Acessibilidade e inclusão",
                                "Conteúdos prontos para aplicar em sala"
                            ].map((feature, i) => (
                                <div key={i} className="flex items-start gap-4 text-slate-600 font-medium group-hover:translate-x-1 transition-transform">
                                    <div className="w-5 h-5 rounded-full bg-[#15b3a8]/10 flex items-center justify-center shrink-0 mt-0.5">
                                        <Check className="w-3 h-3 text-[#15b3a8]" strokeWidth={4} />
                                    </div>
                                    <span>{feature}</span>
                                </div>
                            ))}
                        </div>

                        <button
                            onClick={handleEssencialClick}
                            className="w-full py-3 rounded-full font-black text-white bg-[#3266cc] hover:bg-[#2855b0] shadow-lg shadow-blue-500/20 transition-all active:scale-95 flex items-center justify-center gap-2"
                        >
                            Começar Gratuitamente
                        </button>
                    </div>

                    {/* Pro */}
                    <div className="bg-white rounded-[3rem] p-10 shadow-[0_40px_80px_-20px_rgba(50,102,204,0.15)] border-2 border-[#3266cc] relative flex flex-col z-20 transform md:-translate-y-8 hover:scale-[1.03] transition-all duration-500 group">
                        <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2">
                            <span className="bg-gradient-to-r from-[#3266cc] to-blue-600 text-white text-[10px] font-black px-6 py-2.5 rounded-full uppercase tracking-[0.2em] shadow-xl whitespace-nowrap">
                                ACESSO COMPLETO
                            </span>
                        </div>
                        <div className="mb-6">
                            <span className="text-xs font-black text-[#3266cc] uppercase tracking-[0.2em]">PRO</span>
                            <div className="mt-2 flex items-baseline gap-1">
                                <span className="text-5xl font-black text-[#3266cc] tracking-tighter">
                                    {isAnnual ? "R$ 19,99" : "R$ 29,90"}
                                </span>
                                <span className="text-slate-400 text-lg font-bold tracking-tight">
                                    {isAnnual ? "/mês" : "/mês"}
                                </span>
                            </div>
                        </div>
                        <p className="text-slate-500 text-lg mb-10 leading-relaxed font-medium">
                            O plano ideal para atender sua rotina semanal com total autonomia.
                        </p>

                        <div className="space-y-4 mb-12 flex-grow">
                            {[
                                "Mais gerações",
				"Preferências do professor",
                                "Acervo de conhecimento",
                                "Explicabilidade",
                                "Versão do aluno"
                            ].map((feature, i) => (
                                <div key={i} className="flex items-start gap-4 text-slate-700 font-bold group-hover:translate-x-1 transition-transform">
                                    <div className="w-5 h-5 rounded-full bg-[#15b3a8]/10 flex items-center justify-center shrink-0 mt-0.5">
                                        <Check className="w-3 h-3 text-[#15b3a8]" strokeWidth={4} />
                                    </div>
                                    <span>{feature}</span>
                                </div>
                            ))}
                        </div>

                        <button
                            onClick={handleProClick}
                            className="w-full py-3 rounded-full font-black text-white bg-[#3266cc] hover:bg-[#2855b0] shadow-2xl shadow-blue-500/40 transition-all active:scale-95 flex items-center justify-center gap-2 group/btn"
                        >
                            Assinar Plano PRO	
                            <ChevronRight className="w-5 h-5 group-hover/btn:translate-x-1 transition-transform" />
                        </button>
                    </div>

                    {/* Escolas */}
                    <div className="bg-white rounded-[3rem] p-10 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.08)] border border-slate-100 flex flex-col hover:shadow-2xl hover:scale-[1.02] transition-all duration-500 group">
                        <div className="mb-6">
                            <span className="text-xs font-black text-slate-400 uppercase tracking-[0.2em]">ESCOLAS</span>
                            <div className="mt-2 flex items-baseline">
                                <span className="text-5xl font-black text-[#3266cc] tracking-tighter">Entre em contato</span>
                            </div>
                        </div>
                        <p className="text-slate-500 text-lg mb-10 leading-relaxed font-medium">
                            Solução completa para escolas particulares, redes e instituições.
                        </p>

                        <div className="space-y-4 mb-12 flex-grow">
                            {[
                                "Gestão de múltiplos professores",
                                "Relatórios de impacto pedagógico",
                                "Alinhamento com PPP/PIP",
                                "Suporte dedicado",
                                "Formação continuada"
                            ].map((feature, i) => (
                                <div key={i} className="flex items-start gap-4 text-slate-600 font-medium group-hover:translate-x-1 transition-transform">
                                    <div className="w-5 h-5 rounded-full bg-[#15b3a8]/10 flex items-center justify-center shrink-0 mt-0.5">
                                        <Check className="w-3 h-3 text-[#15b3a8]" strokeWidth={4} />
                                    </div>
                                    <span>{feature}</span>
                                </div>
                            ))}
                        </div>

                        <button
                            onClick={handleEscolaClick}
                            className="w-full py-3 rounded-full font-black text-white bg-[#3266cc] hover:bg-[#2855b0] shadow-lg shadow-blue-500/20 transition-all active:scale-95 flex items-center justify-center gap-2"
                        >
                            Solicitar Proposta
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}
